module.exports = __webpack_public_path__ + "img/52.4dd20a2b.jpg";